var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{attrs:{"stretch":""}},[_vm._t("default",function(){return [_vm._v("no "),_c('code',[_vm._v("exam_processing_speed")]),_vm._v(" component specified")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }